if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        slider: this.querySelector('[id^="Slider-Thumbnails"]'),
        sliderMedia: this.querySelector('[id^="Slider-Gallery"]'),
        thumbnailsArray: this.querySelectorAll('[id^="Slide-Thumbnails"]'),
        prevButton: this.querySelectorAll('button[name="previous"]'),
        nextButton: this.querySelectorAll('button[name="next"]')
      }

      this.elements.sliderItems = this.elements.sliderMedia
        ? this.elements.sliderMedia.querySelectorAll('[id^="Slide-"]')
        : [];
      this.mql = window.matchMedia('(min-width: 769px)');
      this._heightResizeObserver = null;
      this._observedSlideForHeight = null;
      this._heightUpdateScheduled = false;

      if (!this.elements.thumbnails) return;

      this.elements.slider.addEventListener('click', this.setActiveThumbnail.bind(this))
      this.elements.slider.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ENTER') this.setActiveThumbnail(event)
      })
    }

    connectedCallback() {
      const sliderMedia = this.elements.sliderMedia || this.querySelector('[id^="Slider-Gallery"]');

      if (sliderMedia && sliderMedia.classList.contains('gallery__grid-original')) {
        const useOriginal = (window.innerWidth > 1024 && sliderMedia.classList.contains('product__media-list-desktop-original')) ||
          (window.innerWidth <= 1024 && sliderMedia.classList.contains('product__media-list-mobile-original'));

        if (useOriginal) {
          const activeSlide = sliderMedia.querySelector('.is-active');
          if (activeSlide) {
            requestAnimationFrame(() => {
              this._updateSliderHeightToActiveSlide();
              this._observeActiveSlideForHeight(activeSlide);
            });
          }
        }
      }

      requestAnimationFrame(() => {
        const activeSlide = this.elements.sliderMedia
          ? (this.elements.sliderMedia.querySelector('.is-active') || this.elements.sliderItems[0])
          : null;
        this._updateButtonState(activeSlide);
      });
    }

    _updateButtonState(activeMedia) {
      if (!this.elements.prevButton?.length || !this.elements.nextButton?.length || !this.elements.sliderItems?.length) return;

      const activeIndex = activeMedia
        ? Array.from(this.elements.sliderItems).indexOf(activeMedia)
        : 0;

      const disablePrev = activeIndex <= 0;
      const disableNext = activeIndex >= this.elements.sliderItems.length - 1;

      this.elements.prevButton.forEach(btn => btn.toggleAttribute('disabled', disablePrev));
      this.elements.nextButton.forEach(btn => btn.toggleAttribute('disabled', disableNext));
    }

    _shouldUseOriginalHeight() {
      if (!this.elements.sliderMedia || !this.elements.sliderMedia.classList.contains('gallery__grid-original')) return false;

      const isDesktopOriginal = this.elements.sliderMedia.classList.contains('product__media-list-desktop-original');
      const isMobileOriginal = this.elements.sliderMedia.classList.contains('product__media-list-mobile-original');

      return (window.innerWidth > 1024 && isDesktopOriginal) || (window.innerWidth <= 1024 && isMobileOriginal);
    }

    _updateSliderHeightToActiveSlide() {
      if (!this._shouldUseOriginalHeight()) return;

      const activeSlide = this.elements.sliderMedia.querySelector('.is-active');
      if (!activeSlide) return;

      this.elements.sliderMedia.style.height = activeSlide.offsetHeight + 'px';
    }

    _observeActiveSlideForHeight(activeSlide) {
      if (!this._shouldUseOriginalHeight()) return;
      if (this._observedSlideForHeight === activeSlide) return;

      if (this._heightResizeObserver) {
        if (this._observedSlideForHeight) this._heightResizeObserver.unobserve(this._observedSlideForHeight);
        this._observedSlideForHeight = null;
      }

      if (!activeSlide) return;

      this._observedSlideForHeight = activeSlide;

      if (!this._heightResizeObserver) {
        this._heightResizeObserver = new ResizeObserver(() => {
          if (!this._observedSlideForHeight || !this._observedSlideForHeight.classList.contains('is-active')) return;
          if (this._heightUpdateScheduled) return;

          this._heightUpdateScheduled = true;

          requestAnimationFrame(() => {
            this._heightUpdateScheduled = false;
            this._updateSliderHeightToActiveSlide();
          });
        });
      }
      this._heightResizeObserver.observe(activeSlide);
    }

    setActiveMedia(mediaId) { 
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`)
      const prevActiv = this.elements.viewer.querySelector(`.is-active`)

      if (prevActiv) prevActiv.classList.remove('is-active');
      if (activeMedia) activeMedia.classList.add('is-active');
      if (this.elements.viewer.querySelectorAll(`.product__media-item--hide`).length > 0 && activeMedia) {
        let activeMediaAlt = activeMedia.dataset.mediaAlt
        this.elements.viewer.querySelectorAll(`.product__media-item-image`).forEach(media => {
          media.classList.remove('product__media-item--variant-alt', 'product__media-item--show')
          if (media.dataset.mediaAlt == activeMediaAlt) media.classList.add('product__media-item--variant-alt')
        })
      } else if (this.elements.viewer.querySelectorAll(`.product__media-item--hide`).length < 1) {
        const prevActiv = this.elements.viewer.querySelector(`.is-active`)
        if (prevActiv) prevActiv.classList.remove('is-active');
        if (activeMedia) activeMedia.classList.add('is-active');
      }

      if (!activeMedia) return

      if (activeMedia) {
        if (this._shouldUseOriginalHeight()) {
          this.elements.sliderMedia.style.height = '';
          requestAnimationFrame(() => {
            this._updateSliderHeightToActiveSlide();
            this._observeActiveSlideForHeight(activeMedia);
          });
        } else {
          this.elements.sliderMedia.style.height = '';
        }

        window.themeAnimateScrollLeft(this.elements.sliderMedia, activeMedia.offsetLeft);
      }
      if (this.querySelector('[id^="GalleryThumbnails"]')) {
        const prevActiveThumbnail = this.elements.thumbnails.querySelector(`.is-active`)
        if (prevActiveThumbnail) prevActiveThumbnail.classList.remove('is-active')

        let activeMediaAlt
        let mediaIdValue

        if (activeMedia) {
          activeMediaAlt = activeMedia.dataset.mediaAlt
          mediaIdValue = activeMedia.dataset.mediaId
        }

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaIdValue }"]`)

        if (activeThumbnail) activeThumbnail.classList.add('is-active')
        if (this.elements.viewer.querySelectorAll(`.product__media-item--hide`).length > 0 && activeMedia) {
          this.elements.thumbnails.querySelectorAll(`.thumbnail-list__item-image`).forEach(thumbnail => {
            thumbnail.classList.remove('product__media-item--variant-alt', 'product__media-item--show')
            if (thumbnail.dataset.mediaAlt == activeMediaAlt) thumbnail.classList.add('product__media-item--variant-alt')
          })
        } 

        this.elements.slider.scrollTo({
          left: activeThumbnail.offsetLeft - activeThumbnail.offsetWidth - 8,
          behavior: 'smooth'
        })

        if (activeThumbnail.parentElement.classList.contains('thumbnail-list--column')) {
          this.elements.thumbnails.scrollTo({
            top: activeThumbnail.offsetTop - activeThumbnail.offsetHeight - 8,
            behavior: 'smooth'
          })
        }
      }

      if (!activeMedia) return

      this.preventStickyHeader();

      if (window.innerWidth > 768) window.setTimeout(() => {
        if (this.dataset.desktopLayout === 'stack' || this.dataset.desktopLayout === 'grid' || this.dataset.desktopLayout === 'alternative_1' || this.dataset.desktopLayout === 'alternative_2') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });

      this.playActiveMedia(activeMedia);
      if (!this.elements.thumbnails) return;

      this.announceLiveRegion(activeMedia, this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`).dataset.mediaPosition);
    }

    setActiveThumbnail(event) {
      this.elements.sliderMedia.classList.add('disable-scroll')
      if(!event.target.closest('.thumbnail-list__item')) return

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      this.elements.thumbnails.querySelectorAll('li').forEach(item => item.classList.remove('is-active'))
      this.elements.sliderMedia.querySelectorAll('li').forEach(item => item.classList.remove('is-active'))

      let newActiveThumb = event.target.closest('.thumbnail-list__item')
      let activeThumbData = newActiveThumb.dataset.target
      
      let newActiveMedia = this.elements.sliderMedia.querySelector(`[data-media-id="${ activeThumbData }"]`)

      newActiveThumb.classList.add('is-active')
      newActiveThumb.querySelector('button')?.setAttribute('aria-current', true);
      if (newActiveMedia) newActiveMedia.classList.add('is-active')
      if (newActiveMedia) this.playActiveMedia(newActiveMedia);

      setTimeout(() => {
        if (!newActiveMedia) return;

        if (this.dataset.desktopLayout === 'stack' || this.dataset.desktopLayout === 'grid' || this.dataset.desktopLayout === 'alternative_1' || this.dataset.desktopLayout === 'alternative_2') {
          let newActiveMediaTop = newActiveMedia.getBoundingClientRect().top + pageYOffset
          document.documentElement.scrollTo({
            top: newActiveMediaTop,
            behavior: 'smooth'
          })
        }

        if (this._shouldUseOriginalHeight()) {
          this.elements.sliderMedia.style.height = '';
          requestAnimationFrame(() => {
            this._updateSliderHeightToActiveSlide();
            this._observeActiveSlideForHeight(newActiveMedia);
          });
        } else {
          this.elements.sliderMedia.style.height = '';
        }

        window.themeAnimateScrollLeft(this.elements.sliderMedia, newActiveMedia.offsetLeft);

        if (this.elements.slider.classList.contains('thumbnail-list--column')) {
          this.elements.slider.closest('.thumbnail-slider--column').scrollTo({
            top: newActiveThumb.offsetTop - newActiveThumb.offsetHeight - 8,
            behavior: 'smooth'
          })
        } else {
          this.elements.slider.scrollTo({
            left: newActiveThumb.offsetLeft - newActiveThumb.offsetWidth - 8,
            behavior: 'smooth'
          })
        }

        this._updateButtonState(newActiveMedia);
      }, 5)

      setTimeout(() => this.elements.sliderMedia.classList.remove('disable-scroll'), 300)
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;

      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };

      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      if (!activeItem || !this._isVideoAutoplayEnabled(activeItem)) return;

      const deferredMedia = activeItem.querySelector('deferred-media, product-model');
      if (deferredMedia) deferredMedia.loadContent(false, true);
    }

    _isVideoAutoplayEnabled(activeItem) {
      const deferredMedia = activeItem.querySelector('deferred-media, product-model');
      if (deferredMedia?.dataset?.enableAutoplay === 'true') return true;
      return this.querySelector('product-gallery')?.dataset?.enableAutoplay === 'true';
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}  